// import React, { useEffect, useState } from "react";
// import "../Assests/ProjectTask.css";

// import Tickets from "../Components/Tickets"; // ✅ ADD THIS

// import {
//     getAllProjects,
//     addProject,
//     updateProject,
//     deleteProject,
// } from "../Db_Connections/projectsApi";

// export default function ProjectTask({ auth }) {
//     const user = auth || JSON.parse(sessionStorage.getItem("auth"));
//     const isAdmin = user?.role === "Admin" || user?.role === "Super Admin";

//     const [activeTab, setActiveTab] = useState("All Projects");

//     const [projects, setProjects] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [showModal, setShowModal] = useState(false);
//     const [errorMsg, setErrorMsg] = useState("");

//     const [editingProjectId, setEditingProjectId] = useState(null);

//     const [form, setForm] = useState({
//         name: "",
//         description: "",
//         start_date: "",
//         end_date: "",
//         status: "Active",
//     });

//     const [memberInput, setMemberInput] = useState("");
//     const [members, setMembers] = useState([]);

//     const loadProjects = async () => {
//         setLoading(true);
//         const { data, error } = await getAllProjects();
//         if (error) console.error(error);
//         setProjects(data || []);
//         setLoading(false);
//     };

//     useEffect(() => {
//         loadProjects();
//     }, []);

//     const addMemberLocal = () => {
//         const name = memberInput.trim();
//         if (!name) return;
//         if (members.includes(name)) {
//             setMemberInput("");
//             return;
//         }
//         setMembers((prev) => [...prev, name]);
//         setMemberInput("");
//     };

//     const removeMember = (name) => {
//         setMembers((prev) => prev.filter((m) => m !== name));
//     };

//     const resetForm = () => {
//         setForm({
//             name: "",
//             description: "",
//             start_date: "",
//             end_date: "",
//             status: "Active",
//         });
//         setMembers([]);
//         setMemberInput("");
//         setErrorMsg("");
//         setEditingProjectId(null);
//     };

//     const openAddModal = () => {
//         resetForm();
//         setShowModal(true);
//     };

//     const openEditModal = (project) => {
//         setEditingProjectId(project.id);

//         setForm({
//             name: project.name || "",
//             description: project.description || "",
//             start_date: project.start_date || "",
//             end_date: project.end_date || "",
//             status: project.status || "Active",
//         });

//         setMembers(Array.isArray(project.team_members) ? project.team_members : []);
//         setMemberInput("");
//         setErrorMsg("");
//         setShowModal(true);
//     };

//     const handleDelete = async (project) => {
//         const ok = window.confirm(`Delete project "${project.name}"?`);
//         if (!ok) return;

//         const { error } = await deleteProject(project.id);
//         if (error) {
//             alert(error.message);
//             return;
//         }
//         loadProjects();
//     };

//     const handleSubmit = async () => {
//         setErrorMsg("");

//         if (!form.name.trim()) {
//             setErrorMsg("Project name is required.");
//             return;
//         }

//         const payload = {
//             name: form.name,
//             description: form.description,
//             start_date: form.start_date,
//             end_date: form.end_date,
//             status: form.status,
//             team_members: members,
//             created_by: user?.id ?? null,
//         };

//         if (editingProjectId) {
//             const { error } = await updateProject(editingProjectId, payload);
//             if (error) {
//                 setErrorMsg(error.message);
//                 return;
//             }
//         } else {
//             const { error } = await addProject(payload);
//             if (error) {
//                 setErrorMsg(error.message);
//                 return;
//             }
//         }

//         setShowModal(false);
//         resetForm();
//         loadProjects();
//     };

//     return (
//         <div className="pt-container">
//             {/* ✅ Tabs: Tickets + All Projects */}
//             <div className="pt-tabs">
//                 <button
//                     className={`pt-tab ${activeTab === "Tickets" ? "active" : ""}`}
//                     onClick={() => setActiveTab("Tickets")}
//                 >
//                     Tickets
//                 </button>

//                 <button
//                     className={`pt-tab ${activeTab === "All Projects" ? "active" : ""}`}
//                     onClick={() => setActiveTab("All Projects")}
//                 >
//                     All Projects
//                 </button>
//             </div>

//             {/* ✅ Tickets Page */}
//             {activeTab === "Tickets" ? (
//                 <Tickets auth={auth} />
//             ) : (
//                 <>
//                     {/* ✅ All Projects Page (existing UI) */}
//                     <div className="pt-page">
//                         <div className="pt-header">
//                             <h2 className="pt-title">All Projects</h2>

//                             {isAdmin && (
//                                 <button className="pt-add-btn" onClick={openAddModal}>
//                                     Add Project
//                                 </button>
//                             )}
//                         </div>

//                         {loading ? (
//                             <p>Loading...</p>
//                         ) : projects.length === 0 ? (
//                             <div className="pt-empty">No projects found.</div>
//                         ) : (
//                             <div className="pt-grid">
//                                 {projects.map((p) => (
//                                     <div className="pt-card" key={p.id}>
//                                         <div className="pt-card-top">
//                                             <div className="pt-card-name">{p.name}</div>

//                                             <div className="pt-right">
//                                                 <span
//                                                     className={`pt-badge ${String(p.status || "")
//                                                         .toLowerCase()
//                                                         .replaceAll(" ", "-")}`}
//                                                 >
//                                                     {p.status}
//                                                 </span>

//                                                 {isAdmin && (
//                                                     <div className="pt-card-actions">
//                                                         <button
//                                                             type="button"
//                                                             className="pt-icon-btn"
//                                                             title="Edit"
//                                                             onClick={() => openEditModal(p)}
//                                                         >
//                                                             ✏️
//                                                         </button>
//                                                         <button
//                                                             type="button"
//                                                             className="pt-icon-btn"
//                                                             title="Delete"
//                                                             onClick={() => handleDelete(p)}
//                                                         >
//                                                             🗑️
//                                                         </button>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>

//                                         {p.description && (
//                                             <div className="pt-card-desc">{p.description}</div>
//                                         )}

//                                         <div className="pt-card-meta">
//                                             <div>
//                                                 <div className="pt-meta-label">Start</div>
//                                                 <div className="pt-meta-value">
//                                                     {p.start_date || "-"}
//                                                 </div>
//                                             </div>
//                                             <div>
//                                                 <div className="pt-meta-label">End</div>
//                                                 <div className="pt-meta-value">{p.end_date || "-"}</div>
//                                             </div>
//                                         </div>

//                                         <div className="pt-members">
//                                             <div className="pt-meta-label">Team Members</div>
//                                             <div className="pt-member-list">
//                                                 {(p.team_members || []).length === 0 ? (
//                                                     <span className="pt-muted">-</span>
//                                                 ) : (
//                                                     (p.team_members || []).slice(0, 6).map((m) => (
//                                                         <span className="pt-chip" key={m}>
//                                                             {m}
//                                                         </span>
//                                                     ))
//                                                 )}
//                                                 {(p.team_members || []).length > 6 && (
//                                                     <span className="pt-muted">
//                                                         +{(p.team_members || []).length - 6} more
//                                                     </span>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>

//                     {/* ✅ Modal */}
//                     {isAdmin && showModal && (
//                         <div
//                             className="pt-modal-overlay"
//                             onClick={() => {
//                                 setShowModal(false);
//                                 resetForm();
//                             }}
//                         >
//                             <div className="pt-modal" onClick={(e) => e.stopPropagation()}>
//                                 <div className="pt-modal-header">
//                                     <h3>{editingProjectId ? "Edit Project" : "Add Project"}</h3>
//                                     <button
//                                         className="pt-close"
//                                         onClick={() => {
//                                             setShowModal(false);
//                                             resetForm();
//                                         }}
//                                     >
//                                         ×
//                                     </button>
//                                 </div>

//                                 <div className="pt-modal-body">
//                                     {errorMsg && <div className="pt-error">{errorMsg}</div>}

//                                     <div className="pt-form-group">
//                                         <label>Project Name *</label>
//                                         <input
//                                             className="pt-input"
//                                             value={form.name}
//                                             onChange={(e) =>
//                                                 setForm((prev) => ({ ...prev, name: e.target.value }))
//                                             }
//                                             placeholder="Project name..."
//                                         />
//                                     </div>

//                                     <div className="pt-form-group">
//                                         <label>Description</label>
//                                         <textarea
//                                             className="pt-textarea"
//                                             value={form.description}
//                                             onChange={(e) =>
//                                                 setForm((prev) => ({
//                                                     ...prev,
//                                                     description: e.target.value,
//                                                 }))
//                                             }
//                                             placeholder="Project details..."
//                                         />
//                                     </div>

//                                     <div className="pt-form-row">
//                                         <div className="pt-form-group">
//                                             <label>Start Date</label>
//                                             <input
//                                                 type="date"
//                                                 className="pt-input"
//                                                 value={form.start_date}
//                                                 onChange={(e) =>
//                                                     setForm((prev) => ({
//                                                         ...prev,
//                                                         start_date: e.target.value,
//                                                     }))
//                                                 }
//                                             />
//                                         </div>

//                                         <div className="pt-form-group">
//                                             <label>End Date</label>
//                                             <input
//                                                 type="date"
//                                                 className="pt-input"
//                                                 value={form.end_date}
//                                                 onChange={(e) =>
//                                                     setForm((prev) => ({
//                                                         ...prev,
//                                                         end_date: e.target.value,
//                                                     }))
//                                                 }
//                                             />
//                                         </div>
//                                     </div>

//                                     <div className="pt-form-group">
//                                         <label>Status</label>
//                                         <select
//                                             className="pt-input"
//                                             value={form.status}
//                                             onChange={(e) =>
//                                                 setForm((prev) => ({
//                                                     ...prev,
//                                                     status: e.target.value,
//                                                 }))
//                                             }
//                                         >
//                                             <option value="Planned">Planned</option>
//                                             <option value="Active">Active</option>
//                                             <option value="On Hold">On Hold</option>
//                                             <option value="Completed">Completed</option>
//                                         </select>
//                                     </div>

//                                     <div className="pt-form-group">
//                                         <label>Team Members</label>
//                                         <div className="pt-member-add">
//                                             <input
//                                                 className="pt-input"
//                                                 value={memberInput}
//                                                 onChange={(e) => setMemberInput(e.target.value)}
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === "Enter") {
//                                                         e.preventDefault();
//                                                         addMemberLocal();
//                                                     }
//                                                 }}
//                                                 placeholder="Type name and press Enter"
//                                             />
//                                             <button
//                                                 type="button"
//                                                 className="pt-small-btn"
//                                                 onClick={addMemberLocal}
//                                             >
//                                                 Add
//                                             </button>
//                                         </div>

//                                         {members.length > 0 && (
//                                             <div className="pt-chip-wrap">
//                                                 {members.map((m) => (
//                                                     <span className="pt-chip pt-chip-edit" key={m}>
//                                                         {m}
//                                                         <button
//                                                             type="button"
//                                                             onClick={() => removeMember(m)}
//                                                         >
//                                                             ×
//                                                         </button>
//                                                     </span>
//                                                 ))}
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 <div className="pt-modal-footer">
//                                     <button
//                                         className="pt-btn-secondary"
//                                         onClick={() => {
//                                             setShowModal(false);
//                                             resetForm();
//                                         }}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <button className="pt-btn-primary" onClick={handleSubmit}>
//                                         {editingProjectId ? "Update Project" : "Save Project"}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </>
//             )}
//         </div>
//     );
// }
import React, { useEffect, useState } from "react";
import "../Assests/ProjectTask.css";
import Tickets from "../Components/Tickets";

import {
    getAllProjects,
    addProject,
    updateProject,
    deleteProject,
} from "../Db_Connections/projectsApi";

import { supabase } from "../Db_Connections/db_connection";

export default function ProjectTask({ auth }) {
    const user = auth || JSON.parse(sessionStorage.getItem("auth"));
    const isAdmin = user?.role === "Admin" || user?.role === "Super Admin";

    const [activeTab, setActiveTab] = useState("All Projects");
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [editingProjectId, setEditingProjectId] = useState(null);

    const [allActiveUsers, setAllActiveUsers] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);

    const [form, setForm] = useState({
        name: "",
        description: "",
        start_date: "",
        end_date: "",
        status: "Active",
        manager: "",
    });

    const loadProjects = async () => {
        setLoading(true);
        const { data, error } = await getAllProjects();
        if (error) console.error(error);
        setProjects(data || []);
        setLoading(false);
        console.log("project data",data);
        
    };

    const loadActiveUsers = async () => {
        const { data, error } = await supabase
            .from("profiles")
            .select("id,first_name, last_name, email, is_active")
            .eq("is_active", true)
            .order("first_name");

        if (error) {
            console.error("Error loading active users:", error);
            return;
        }

        const formatted = (data || []).map(user => {
            const fullName = `${user.first_name || ""} ${user.last_name || ""}`.trim();

            return {                 // Most important for manager selection
                id: user.id,
                fullName: fullName || user.email,   // Display name
                email: user.email
            };
        });

        setAllActiveUsers(formatted);
    };


    useEffect(() => {
        loadProjects();
        loadActiveUsers();
    }, []);

    console.log("all user",allActiveUsers);
    
    // Available users = all active - selected
    const availableUsers = allActiveUsers.filter(user =>
        !selectedMembers.includes(user.email)
    );
    const addMember = (email) => {
        if (!email) return;
        if (selectedMembers.includes(email)) return;

        setSelectedMembers(prev => [...prev, email]);
    };


    const removeMember = (name) => {
        setSelectedMembers(prev => prev.filter(m => m !== name));
        if (form.manager_email === name) {
            setForm(prev => ({ ...prev, manager: "" }));
        }
    };

    const resetForm = () => {
        setForm({
            name: "",
            description: "",
            start_date: "",
            end_date: "",
            status: "Active",
            manager: "",
        });
        setSelectedMembers([]);
        setErrorMsg("");
        setEditingProjectId(null);
    };

    const openAddModal = () => {
        resetForm();
        setShowModal(true);
    };

    const openEditModal = (project) => {
        setEditingProjectId(project.id);
        setForm({
            name: project.name || "",
            description: project.description || "",
            start_date: project.start_date || "",
            end_date: project.end_date || "",
            status: project.status || "Active",
            manager: project.manager || "",
        });
        setSelectedMembers(Array.isArray(project.team_members) ? project.team_members : []);
        setShowModal(true);
    };

    const handleDelete = async (project) => {
        if (!window.confirm(`Delete project "${project.name}"?`)) return;
        const { error } = await deleteProject(project.id);
        if (error) alert(error.message);
        else loadProjects();
    };

    const handleSubmit = async () => {
        setErrorMsg("");

        if (!form.name.trim()) return setErrorMsg("Project name is required.");
        if (!form.manager) return setErrorMsg("Please select a Manager.");
        console.log("all data", form);

         const payload = {
            name: form.name,
            description: form.description,
            start_date: form.start_date,
            end_date: form.end_date,
            status: form.status,
            manager: form.manager ? Number(form.manager) : null,
            team_members: selectedMembers,
            created_by: user?.id ?? null,
        };
        console.log("payload data",payload);
        


        let error;
        if (editingProjectId) {
            ({ error } = await updateProject(editingProjectId, payload));
        } else {
            ({ error } = await addProject(payload));
        }

        if (error) {
            setErrorMsg(error.message);
            return;
        }

        setShowModal(false);
        resetForm();
        loadProjects();
    };
    

    return (
        <div className="pt-container">
            <div className="pt-tabs">
                <button className={`pt-tab ${activeTab === "Tickets" ? "active" : ""}`} onClick={() => setActiveTab("Tickets")}>Tickets</button>
                <button className={`pt-tab ${activeTab === "All Projects" ? "active" : ""}`} onClick={() => setActiveTab("All Projects")}>All Projects</button>
            </div>

            {activeTab === "Tickets" ? (
                <Tickets auth={auth} />
            ) : (
                <>
                    <div className="pt-page">
                        <div className="pt-header">
                            <h2 className="pt-title">All Projects</h2>
                            {isAdmin && <button className="pt-add-btn" onClick={openAddModal}>Add Project</button>}
                        </div>

                        {loading ? <p>Loading...</p> : projects.length === 0 ? (
                            <div className="pt-empty">No projects found.</div>
                        ) : (
                            <div className="pt-grid">
                                {projects.map((p) => (
                                    <div className="pt-card" key={p.id}>
                                        {/* ... same card code as before ... */}
                                        <div className="pt-card-top">
                                            <div className="pt-card-name">{p.name}</div>
                                            <div className="pt-right">
                                                <span className={`pt-badge ${String(p.status || "").toLowerCase().replaceAll(" ", "-")}`}>{p.status}</span>
                                                {isAdmin && (
                                                    <div className="pt-card-actions">
                                                        <button type="button" className="pt-icon-btn" onClick={() => openEditModal(p)}>✏️</button>
                                                        <button type="button" className="pt-icon-btn" onClick={() => handleDelete(p)}>🗑️</button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {p.description && <div className="pt-card-desc">{p.description}</div>}
                                        <div className="pt-card-meta">
                                            <div>
                                                <div className="pt-meta-label">Manager</div>
                                                <div className="pt-meta-value"><strong>{p.profiles.first_name || "-"}</strong></div>
                                            </div>
                                            <div>
                                                <div className="pt-meta-label">Start</div>
                                                <div className="pt-meta-value">{p.start_date || "-"}</div>
                                            </div>
                                            <div>
                                                <div className="pt-meta-label">End</div>
                                                <div className="pt-meta-value">{p.end_date || "-"}</div>
                                            </div>
                                        </div>
                                        <div className="pt-members">
                                            <div className="pt-meta-label">Team Members</div>
                                            <div className="pt-member-list">
                                                {(p.team_members || []).length === 0 ? (
                                                    <span className="pt-muted">-</span>
                                                ) : (
                                                    (p.team_members || []).slice(0, 6).map((m, i) => (
                                                        <span className="pt-chip" key={i}>{m}</span>
                                                    ))
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* ===================== MODAL ===================== */}
                    {isAdmin && showModal && (
                        <div className="pt-modal-overlay" onClick={() => { setShowModal(false); resetForm(); }}>
                            <div className="pt-modal" onClick={e => e.stopPropagation()}>
                                <div className="pt-modal-header">
                                    <h3>{editingProjectId ? "Edit Project" : "Add Project"}</h3>
                                    <button className="pt-close" onClick={() => { setShowModal(false); resetForm(); }}>×</button>
                                </div>

                                <div className="pt-modal-body">
                                    {errorMsg && <div className="pt-error">{errorMsg}</div>}

                                    <div className="pt-form-group">
                                        <label>Project Name *</label>
                                        <input className="pt-input" value={form.name} onChange={(e) => setForm(prev => ({ ...prev, name: e.target.value }))} />
                                    </div>

                                    {/* Team Members - Chips + Available Dropdown */}
                                    <div className="pt-form-group">
                                        <label>Team Members</label>

                                        {/* Selected Chips */}
                                        {selectedMembers.length > 0 && (
                                            <div className="pt-chip-wrap" style={{ marginBottom: "10px" }}>
                                                {selectedMembers.map(m => (
                                                    <span className="pt-chip pt-chip-edit" key={m}>
                                                        {m}
                                                        <button onClick={() => removeMember(m)}>×</button>
                                                    </span>
                                                ))}
                                            </div>
                                        )}

                                        {/* Available Users Dropdown */}
                                            {/* Available Users Dropdown */}
                                            {availableUsers?.length > 0 && (
                                                <select
                                                    className="pt-input"
                                                    onChange={(e) => addMember(e.target.value)}
                                                    value=""
                                                >
                                                    <option value="">Add Team Member...</option>
                                                    {availableUsers.map((user) => (
                                                        <option key={user.id} value={user.fullName}>
                                                            {user.fullName}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                    </div>

                                        <div className="pt-form-group">
                                            <label>Manager Name *</label>
                                            <select
                                                className="pt-input"
                                                value={form.manager}
                                                onChange={(e) =>
                                                    setForm(prev => ({ ...prev, manager: Number(e.target.value) }))
                                                }
                                            >
                                                <option value="">Select Manager</option>

                                                {selectedMembers.map(fullName => {
                                                    const user = allActiveUsers.find(u => u.fullName === fullName);

                                                    if (!user) return null;

                                                    return (
                                                        <option key={user.id} value={user.id}>
                                                            {user.fullName}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    {/* Other fields remain same */}
                                    <div className="pt-form-group">
                                        <label>Description</label>
                                        <textarea className="pt-textarea" value={form.description} onChange={(e) => setForm(prev => ({ ...prev, description: e.target.value }))} />
                                    </div>

                                    <div className="pt-form-row">
                                        <div className="pt-form-group">
                                            <label>Start Date</label>
                                            <input type="date" className="pt-input" value={form.start_date} onChange={(e) => setForm(prev => ({ ...prev, start_date: e.target.value }))} />
                                        </div>
                                        <div className="pt-form-group">
                                            <label>End Date</label>
                                            <input type="date" className="pt-input" value={form.end_date} onChange={(e) => setForm(prev => ({ ...prev, end_date: e.target.value }))} />
                                        </div>
                                    </div>

                                    <div className="pt-form-group">
                                        <label>Status</label>
                                        <select className="pt-input" value={form.status} onChange={(e) => setForm(prev => ({ ...prev, status: e.target.value }))}>
                                            <option value="Planned">Planned</option>
                                            <option value="Active">Active</option>
                                            <option value="On Hold">On Hold</option>
                                            <option value="Maintenance">Maintenance</option>
                                            <option value="Completed">Completed</option>
                                            
                                        </select>
                                    </div>
                                </div>

                                <div className="pt-modal-footer">
                                    <button className="pt-btn-secondary" onClick={() => { setShowModal(false); resetForm(); }}>Cancel</button>
                                    <button className="pt-btn-primary" onClick={handleSubmit}>
                                        {editingProjectId ? "Update Project" : "Save Project"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}